import React from "react";
import { Empty } from "antd";
import HomeDashboardLoading from "../../pages/Dashboard/HomeDashboardLoading";
import "../../pages/Dashboard/Dashboard.scss";

/** Liste / boş alan — bağlama uygun açıklama ("Veri yok" yerine). */
export function PanelEmpty({
 title,
 description,
 action = null,
 className = "",
}) {
 return (
  <div className={`panel-empty ${className}`.trim()}>
   <Empty
    image={Empty.PRESENTED_IMAGE_SIMPLE}
    description={
     <div className="panel-empty__copy">
      {title ? <strong className="panel-empty__title">{title}</strong> : null}
      {description ? (
       <p className="panel-empty__desc">{description}</p>
      ) : null}
     </div>
    }
   />
   {action ? <div className="panel-empty__action">{action}</div> : null}
  </div>
 );
}

/**
 * Sayfa / liste yüklenme — anasayfa dashboard loading ile aynı.
 * @param {boolean} [embedded] Modal / kart / sekme içi: sabit viewport overlay kullanma.
 */
export function PanelLoading({ tip = "Yükleniyor…", embedded = false }) {
 return (
  <div
   className={`panel-loading${embedded ? " panel-loading--embedded" : ""}`.trim()}
  >
   <HomeDashboardLoading tip={tip} />
  </div>
 );
}

/** Kart / dosya / yatay liste yüklenirken gerçek yerleşimi koruyan skeleton. */
export function PanelCardSkeletons({
 count = 6,
 variant = "course",
 className = "",
}) {
 const items = Array.from({ length: count }, (_, index) => index);

 return (
  <div
   className={`panel-card-skeletons panel-card-skeletons--${variant} ${className}`.trim()}
   role="status"
   aria-label="İçerik yükleniyor"
   aria-busy="true"
  >
   {items.map((index) => (
    <div
     className={`panel-card-skeleton panel-card-skeleton--${variant}`}
     key={index}
     aria-hidden="true"
    >
     {variant !== "row" ? (
      <div className="panel-card-skeleton__media" />
     ) : null}
     <div className="panel-card-skeleton__content">
      <span className="panel-card-skeleton__line panel-card-skeleton__line--short" />
      <span className="panel-card-skeleton__line panel-card-skeleton__line--title" />
      <span className="panel-card-skeleton__line panel-card-skeleton__line--meta" />
     </div>
     <div className="panel-card-skeleton__actions">
      <span />
      {variant !== "file" ? <span /> : null}
     </div>
    </div>
   ))}
  </div>
 );
}

export default PanelEmpty;
